import "./App.css";
import React, { useState } from "react";
import axios from "axios";
import DataWeather from "./DataWeather";
import Unit from "./Unit";
import WeatherIcon from "./WeatherIcon";
import WeatherForecast from "./WeatherForecast";

function App() {
  let [city, setCity] = useState("");
  let [message, setMessage] = useState("");

  const apiKey = "8c48afa47a9a9c24f3500c7039d50aaa";

  function handleSubmit(event) {
    event.preventDefault();
    if (city.length > 2) {
      const apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;

      axios.get(apiUrl).then((response) => {
        const tempData = response.data.main.temp;
        let date = new Date(response.data.dt * 1000);

        let newMessage = (
          <div>
            <div className="row">
              <ul className="main">
                <li>
                  <h1>{response.data.name}</h1>
                </li>
                <li>
                  <h4>
                    <DataWeather date={date} />
                  </h4>
                </li>
              </ul>
            </div>

            <div className="row">
              <div className="col-6">
                {" "}
                <ul>
                  <li>
                    <WeatherIcon
                      icon={response.data.weather[0].icon}
                      size="64"
                    />
                  </li>
                  <Unit metric={tempData} />
                </ul>
              </div>

              <div className="col-6" id="parameters">
                {" "}
                <ul>
                  <li className="text-capitalize">
                    {response.data.weather[0].description}
                  </li>
                  <li>Humidity:{response.data.main.humidity}%</li>
                  <li>Wind:{response.data.wind.speed}km/h</li>
                </ul>
              </div>
            </div>
            <WeatherForecast coord={response.data.coord} />
            <div className="row">
              <a
                href="https://github.com/Olga-Djomkina/weather-react"
                id="link"
              >
                See the source code by clicking here
              </a>
            </div>
          </div>
        );

        setMessage(newMessage);
      });
    } else {
      setMessage("Enter a city");
    }
  }

  function updateCity(event) {
    setCity(event.target.value);
  }

  return (
    <div className="App">
      <header className="App-header">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-9">
              <div className="mb-3">
                <input
                  type="search"
                  className="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  placeholder="Enter a city"
                  onChange={updateCity}
                ></input>
              </div>
            </div>
            <div className="col-3">
              <button type="submit" className="btn btn-primary" id="button">
                Submit
              </button>
            </div>
          </div>
        </form>
        <h2>{message}</h2>
      </header>
    </div>
  );
}

export default App;
